import { PessoaBaseModel } from '../../../core/models/pessoa.model';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { EnumDataset } from '../../../core/enums/enum-dataset';
import { SpeedDialModule } from 'primeng/speeddial';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { TitleComponent } from '../../../core/componentes/Title/title.component';
import { PlanoService } from '../service/plano.service';
import { VoltarComponent } from '../../../core/componentes/voltar/voltar.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { PlanoModel } from '../models/plano.model';
import { FuncionalidadeModel } from '../../gestaoSistema/models/funcionalidade.model';
import { PlanoFuncionalidadeModel } from '../models/plano.funcionalidade.model';
@Component({
  selector: 'app-plano',
  templateUrl: './plano.gestao.html',
  styleUrl: './plano.gestao.scss',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    DropdownModule,
    InputMaskModule,
    SpeedDialModule,
    TableModule,
    ToastModule,
    TagModule,
    TitleComponent,
    VoltarComponent,
    InputNumberModule,
    DialogModule,
  ],
})
export class PlanoGestao implements OnInit {
  public translate = inject(TranslateService);
  constructor(private formBuilder: FormBuilder, private router: Router) {}

  //#region Service
  planoService = inject(PlanoService);
  route = inject(ActivatedRoute);

  //#endregion

  //#region Inicialização
  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';
  value: string = '';
  formBuscarFuncionalidade: FormGroup = this.initFormularioFuncionalidade();
  formAddEditarFuncionalidade: FormGroup =
    this.initFormularioAddEditarFuncionalidade();

  plano: PlanoModel = {
    id: 0,
    nome: '',
    aplicacao: 0,
    status: true,
  };

  funcionalidadesPlano: FuncionalidadeModel[] = [];
  funcionalidades: FuncionalidadeModel[] = [];
  funcionalidadesSelecionadas: FuncionalidadeModel[] = [];

  showAddFuncionalidade: boolean = false;
  showEditarFuncionalidade: boolean = false;
  total: number = 0;

  showAddFuncionalidadeDialog() {
    this.showAddFuncionalidade = true;
    this.buscarFuncionalidades();
  }
  showEditarFuncionalidadeDialog(funcionalidade: FuncionalidadeModel) {
    this.formAddEditarFuncionalidade.patchValue(funcionalidade);
    this.showEditarFuncionalidade = true;
  }

  limparFormularioFuncionalidade() {
    this.formAddEditarFuncionalidade =
      this.initFormularioAddEditarFuncionalidade();
    this.showEditarFuncionalidade = false;
  }

  initFormularioFuncionalidade() {
    this.formBuscarFuncionalidade = this.formBuilder.group({
      id: null,
      nome: null,
      aplicacao: null,
      descricao: null,
      valor: null,
    });
    return this.formBuscarFuncionalidade;
  }
  initFormularioAddEditarFuncionalidade() {
    this.formAddEditarFuncionalidade = this.formBuilder.group({
      id: null,
      planoId: null,
      nome: null,
      aplicacao: null,
      descricao: null,
      valor: null,
    });

    return this.formAddEditarFuncionalidade;
  }

  ngOnInit() {
    var planoId = 0;
    this.route.paramMap.subscribe((params) => {
      planoId = +params.get('id')!; // Obtém o valor do parâmetro 'id'
    });

    this.buscarplano(planoId);
  }

  buscarplano(planoId: number) {
    this.planoService.buscarPlanoPorId(planoId).then((res) => {
      this.plano = res;
      this.buscarFuncionalidadesPlano();
    });
  }

  buscarFuncionalidadesPlano() {
    const filtros = this.formBuscarFuncionalidade.value;
    filtros.planoId = this.plano.id;

    // Dados iniciais (seu mock de exemplo)
    this.planoService.buscarFuncionalidadesPlano(filtros).then((data) => {
      this.funcionalidadesPlano = data;
      this.total = this.funcionalidadesPlano.reduce(
        (acumulador, valorAtual) => acumulador + (valorAtual.valor ?? 0),
        0
      );
    });
  }

  buscarFuncionalidades() {
    // Dados iniciais (seu mock de exemplo)
    this.planoService
      .buscarFuncionalidades({ aplicacao: this.plano.aplicacao })
      .then((data) => {
        this.funcionalidades = data;
        this.funcionalidades = this.funcionalidades.filter(
          (m) => !this.funcionalidadesPlano.some((f) => f.id === m.id)
        ) as FuncionalidadeModel[];
      });
  }

  //#endregion

  //#region Actions

  salvarplano() {
    var formulario = this.formBuscarFuncionalidade.value;

    this.plano.nome = formulario.nome;
    this.plano.aplicacao = formulario.aplicacao;
    this.plano.id = formulario.id;

    this.planoService.salvarPlano(this.plano);
  }

  salvarFuncionalidade() {
    this.showAddFuncionalidade = false;
    const funcionalidadePlano: PlanoFuncionalidadeModel = {
      planoId: this.plano.id,
      funcionalidadesId: this.funcionalidadesSelecionadas.map(
        (m) => m.id
      ) as number[],
    };

    this.planoService.vincularFuncionalidade(funcionalidadePlano);
  }

  desvincularFuncionalidade(funcionalidade: FuncionalidadeModel) {
    const funcionalidadePlano: PlanoFuncionalidadeModel = {
      planoId: this.plano.id,
      funcionalidadesId: [funcionalidade.id],
    };

    this.planoService.desvincularFuncionalidade(funcionalidadePlano);
  }
  //#endregion
}
